import React from 'react';
import styles from './description.module.scss';
import getSkin from './skin.js';
import { css } from 'aphrodite/no-important';
import applyWrappers from 'wrappers/ComponentWrapper';

const Description = (props) => {
    const myStyles = getSkin(props.skinGuide);

    return (
        <div className={props.fontSizeSmaller ? css(myStyles.descSmaller) : css(myStyles.desc) }>
             {props.desc}
        </div>
    )
}

export default applyWrappers(Description, styles);
